import { topSidePartOfWeb } from './parts/sideParts'

export const basketForPitcherWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // バスケット部分
  ctx.beginPath()
  ctx.moveTo(250, 264) // 左上
  ctx.quadraticCurveTo(292, 333, 292, 333) // 左下1
  ctx.quadraticCurveTo(322, 290, 349, 245) // 右下1
  ctx.quadraticCurveTo(332, 151, 332, 151) // 右上1
  ctx.quadraticCurveTo(284, 198, 250, 264) // 左上1
  // ctx.fill()
  // 区切りライン 横方向
  ctx.moveTo(257, 275) // 左
  ctx.quadraticCurveTo(334, 168, 334, 168) // 右
  ctx.moveTo(266, 289) // 左
  ctx.quadraticCurveTo(338, 189, 338, 189) // 右
  ctx.moveTo(276, 306) // 左
  ctx.quadraticCurveTo(342, 211, 342, 211) // 右
  ctx.moveTo(284, 318) // 左
  ctx.quadraticCurveTo(346, 229, 346, 229) // 右
  // 区切りライン 縦方向
  ctx.moveTo(264, 240) // 上
  ctx.quadraticCurveTo(305, 313, 305, 313) // 下
  ctx.moveTo(277, 219) // 上
  ctx.quadraticCurveTo(318, 295, 318, 295) // 下
  ctx.moveTo(295, 192) // 上
  ctx.quadraticCurveTo(329, 276, 329, 276) // 下
  ctx.moveTo(313, 172) // 上
  ctx.quadraticCurveTo(340, 258, 340, 258) // 下
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // バスケットの周り
  // 内側
  ctx.moveTo(247, 265) //左上
  ctx.quadraticCurveTo(292, 337, 292, 337) // 左下
  ctx.quadraticCurveTo(323, 295, 352, 243) // 右下
  ctx.quadraticCurveTo(334, 146, 334, 146) // 右上
  ctx.quadraticCurveTo(281, 194, 247, 265) // 左上
  // 外側
  ctx.moveTo(242, 265) //左上
  ctx.quadraticCurveTo(290, 341, 290, 344) // 左下
  ctx.quadraticCurveTo(328, 300, 356, 241) // 右下
  ctx.quadraticCurveTo(336, 140, 336, 140) // 右上
  ctx.quadraticCurveTo(278, 191, 242, 265) // 左上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
}
